/**
 * Password rule matching the mobile app: length 8-80 characters, at least one
 * lowercase letter [a-z], at least one uppercase letter [A-Z], and at least
 * one digit [0-9]. Special characters are allowed but never required.
 *
 * This is client-side UX only — it never changes what gets sent to the API.
 * Passwords are never trimmed: leading/trailing spaces count toward length
 * and are sent as typed.
 */

const LOWER_RE = /[a-z]/;
const UPPER_RE = /[A-Z]/;
const DIGIT_RE = /[0-9]/;

/**
 * @param {string} pw
 * @returns {{ ok: boolean, lengthOk: boolean, hasLower: boolean, hasUpper: boolean, hasDigit: boolean }}
 */
export const checkPassword = pw => {
  const value = typeof pw === 'string' ? pw : '';

  const lengthOk = value.length >= 8 && value.length <= 80;
  const hasLower = LOWER_RE.test(value);
  const hasUpper = UPPER_RE.test(value);
  const hasDigit = DIGIT_RE.test(value);

  return {
    ok: lengthOk && hasLower && hasUpper && hasDigit,
    lengthOk,
    hasLower,
    hasUpper,
    hasDigit,
  };
};
